import React, { Component } from 'react';

class DialogHeader extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div className={`chartHeaderBar ${this.props.classicClass}`}>
                <div className={`chartbgColor ${this.props.classicClass} ${this.props.posModalNameClassic}`}>
                    <span className={`whiteFontColor font_jakarta long-text-handle`}>{this.props.text && this.props.text.length > 90 ? this.props.text.substring(0, 90) + "..." : this.props.text || ``}</span>
                    <div className={`bg-svg`}>
                        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" className={`bg-svg`}>
                            <rect className="sideZero" width="40" height="40"/>
                            <path className="sideOne" d="M0,0v40h1.45L26.44,6.73C29.55,2.65,34.87,0,40,0H0z"/>
                        </svg>
                    </div>
                </div>
            </div>
        );
    }
}

export default DialogHeader;
